module.exports = __webpack_public_path__ + "static/img/watch4.28005a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/watch4.png
// module id = 9D1r
// module chunks = 8